import { frontendURL } from '../../../helper/URLHelper';
const NotificationsView = () => import('./components/NotificationsView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/notifications'),
    name: 'notifications_index',
    component: NotificationsView,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
